const NAME = "ASSETS_DISCOUNTS_ENTRY_PER_SOCIETY";

export default NAME;
